import {ApplicationConfig, provideBrowserGlobalErrorListeners} from '@angular/core'
import {provideRouter, withComponentInputBinding, withHashLocation} from '@angular/router'

import {routes} from './app.routes'
import {provideHttpClient, withFetch} from '@angular/common/http'
import {LOCAL_STORAGE} from './0-general/providers'

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withHashLocation(), withComponentInputBinding()),
    provideHttpClient(withFetch()),
    {provide: LOCAL_STORAGE, useValue: localStorage}
  ]
}
